import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TipInventoryTable from "./TipInventoryTable";
import EndPoints from "../../../Api/Endpoints";
import { GET } from "../../../Api/HttpsMethods";

const TipDashboard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
}) => {
  const navigate = useNavigate();
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (dataClient) {
      fetchDashboardData();
    }
  }, [dataClient]);

  const fetchDashboardData = async () => {
    try {
      const API_ENDPOINT = `${EndPoints.GET_TIP_INVENTORY_DASHBOARD}`;
      
      const result = await GET.withToken(API_ENDPOINT);
      
      console.log("API Result:", result);
      
      const allData = result?.headers || [];
      const headerRow = allData.filter(item => typeof item === 'string');
      const dataRows = allData.filter(item => Array.isArray(item));
      
      const formattedHeaders = headerRow.map((header) =>
        header.replace(/^[ntd]\*/, "")
      );

      const transformedRows = dataRows.map((row) =>
        row.map((cell, index) => {
          const header = headerRow[index];
          if (header && (header.startsWith("d*") || header.toLowerCase().includes("date"))) {
            if (!cell) return "---";
            try {
              const date = new Date(cell);
              // Removed hour and minute to show only date
              return date.toLocaleDateString("en-IN", {
                year: "numeric",
                month: "short",
                day: "2-digit",
              });
            } catch {
              return cell;
            }
          }

          return cell === "" || cell === null || cell === undefined
            ? "---"
            : cell;
        })
      );

      setHeaders(formattedHeaders);
      setReportDashboardData(transformedRows);
      
      console.log("State set - Headers:", formattedHeaders, "Data:", transformedRows);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  const handleAddRow = () => {
    const emptyRow = new Array(headers.length).fill("");
    setReportDashboardData((prevData) => [...prevData, emptyRow]);
  };

   return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "37px",
        marginBottom: "40px",
      }}
    >
      <div>
        <div
          style={{
            backgroundColor: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            zIndex: 1001,
            top: 0,
          }}
        >
          <p
            style={{
              color: "#6A6A6A",
              fontSize: "30px",
            }}
          >
            Tips Dashboard
          </p>
          <button
            style={{
              padding: "12px",
              marginRight: "18px",
              boxShadow: "0px 4px 4px 0px #00000040",
              marginTop: "0",
            }}
            className="create-test-section-btn"
            onClick={() => navigate("/schedule_tips_of_days")}
          >
            SCHEDULE
          </button>
        </div>
        <p
          style={{
            marginTop: "1%",
            color: "#6A6A6A",
          }}
        >
          All tip requests and their current statuses are listed here.
          Click on a Tip ID to view details, track progress, edit,
          or manage the tip inventory records.
        </p>
        <div>
          <TipInventoryTable
            headers={headers}
            data={reportDashboardData}
            searchPlaceholder="Filter Tip Requests..."
            dataClient={dataClient}
            setPagePath={setPagePath}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            bulk={false}
            handleAddRow={handleAddRow}
            setReportDashboardData={setReportDashboardData}
          />
        </div>
      </div>
    </div>
  );
};

export default TipDashboard;










// import React, { useState, useEffect } from "react";
// import TipInventoryTable from "./TipInventoryTable";
// import dummyData from "./TipInventoryDummyData.json";

// const TipInventory = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath,
// }) => {
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const [headers, setHeaders] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);

//   useEffect(() => {
//     loadDummyData();
//   }, []);

//   const loadDummyData = () => {
//     try {
//       const headers = dummyData.headers || [];
//       const rows = dummyData.rows || [];

//       const transformedRows = rows.map((row) =>
//         row.map((cell, index) => {
//           if (
//             headers[index] === "Create Date" ||
//             headers[index] === "Due By"
//           ) {
//             if (!cell) return "";

//             try {
//               const date = new Date(cell);

//               return date.toLocaleDateString("en-US", {
//                 year: "numeric",
//                 month: "short",
//                 day: "2-digit",
//                 hour: "2-digit",
//                 minute: "2-digit",
//               });
//             } catch {
//               return cell;
//             }
//           }

//           if (cell === "" || cell === null || cell === undefined) {
//             return "";
//           }

//           return cell;
//         })
//       );

//       setHeaders(headers);
//       setReportDashboardData(transformedRows);
//     } catch (error) {
//       console.error("Error loading dummy data:", error);
//     }
//   };

//   const handleAddRow = () => {
//     const emptyRow = new Array(headers.length).fill("");

//     setReportDashboardData((prevData) => [
//       ...prevData,
//       emptyRow,
//     ]);
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "37px",
//         marginBottom: "40px",
//       }}
//     >
//       <div>
//         <div
//           style={{
//             backgroundColor: "white",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             zIndex: 1001,
//             top: 0,
//           }}
//         >
//           <p
//             style={{
//               color: "#6A6A6A",
//               fontSize: "30px",
//             }}
//           >
//             Tip Inventory & Status
//           </p>

//           <button
//             style={{
//               padding: "12px",
//               marginRight: "18px",
//               boxShadow: "0px 4px 4px 0px #00000040",
//               marginTop: "0",
//             }}
//             className="create-test-section-btn"
//           >
//             SAVE
//           </button>
//         </div>
//         <p
//           style={{
//             marginTop: "1%",
//             color: "#6A6A6A",
//           }}
//         >
//           All tip requests and their current statuses are listed here.
//           Click on a Tip ID to view details, track progress, edit,
//           or manage the tip inventory records.
//         </p>

//         {/* Table */}
//         <div>
//           <TipInventoryTable
//             headers={headers}
//             data={reportDashboardData}
//             searchPlaceholder="Filter Tip Requests..."
//             dataClient={dataClient}
//             setPagePath={setPagePath}
//             selectedRows={selectedRows}
//             setSelectedRows={setSelectedRows}
//             bulk={false}
//             handleAddRow={handleAddRow}
//             setReportDashboardData={setReportDashboardData}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TipInventory;